import { mutatorAction } from 'satcheljs';
import type { FormatState, StyleBasedFormatState } from 'roosterjs-editor-types';
import { FONT_NAME_LIST, getLocalizedFontName } from 'owa-format-options';

const FIRSTFONT_REGEX: RegExp = /^['"]?([^'",]+)/i;

/**
 * Second class states are the format states showing in drop down menu, such as font family, font size, colors, ...
 * These states only need to be updated when user click a button to show dropdown.
 */
const updateSecondClassState = mutatorAction(
    'updateRibbonFormatState',
    (formatViewState: FormatState, styleBasedState: StyleBasedFormatState) => {
        // Check font name to ensure it matches the format we have as in FONT_NAME_LIST
        // The returned fontName could be a list of serveral fonts, i.e. Calibri, Arial, Helvetica, sans-serif
        // Let's only take the first one from the list
        if (styleBasedState?.fontName) {
            // FIRSTFONT_REGEX is a group regex. The result at index 1 is the font we're after
            let matches: string[] = styleBasedState.fontName.match(FIRSTFONT_REGEX);
            const fontName = matches && matches.length == 2 ? matches[1] : '';
            const fontNameLowerCase = fontName.toLowerCase();
            const matchedFont = FONT_NAME_LIST.filter(
                font => font.name.toLowerCase() == fontNameLowerCase
            )[0];
            formatViewState.fontName = matchedFont ? getLocalizedFontName(matchedFont) : fontName;
        } else {
            formatViewState.fontName = '';
        }

        // Check font size to ensure it matches the format we have in FONT_SIZE_LIST
        if (styleBasedState) {
            let fs: number = parseInt(styleBasedState.fontSize);
            formatViewState.fontSize = isNaN(fs) ? '' : fs.toString();
            formatViewState.backgroundColor = styleBasedState.backgroundColor;
            formatViewState.textColor = styleBasedState.textColor;
        }
    }
);

export default updateSecondClassState;
